export default __webpack_public_path__ + "static/media/pantry1-afterB-1440w.f3ff521d.webp";